import styled from 'styled-components'

export const Container = styled.div`
  padding: 0 0 20px;
  max-width: 400px;
`
